import React from 'react'
import { Box } from '@chatterbug/aaron'
import Flag, { SIZES } from 'src/components/Flag/Flag'
import { LanguageCode } from 'src/types'

export type Props = {
  languages: LanguageCode[]
}

const LanguageFlags: React.FC<Props> = ({ languages }) => {
  const highestIndex = languages.length

  return (
    <>
      {languages.map((language, index) => {
        return (
          <Box
            key={language}
            data-testid="language-flag"
            as="span"
            ml={index > 0 ? `-${Math.round(SIZES.s.px / 3)}px` : '0'}
            minWidth="22px"
            sx={{ zIndex: index === 0 ? highestIndex : highestIndex - index }}
          >
            <Flag size="s" countryCode={language} borderColor="dark" />
          </Box>
        )
      })}
    </>
  )
}

export default LanguageFlags
